import { render, staticRenderFns } from "./ChatPaletteTabs.vue?vue&type=template&id=2053346a&lang=pug&"
import script from "./ChatPaletteTabs.vue?vue&type=script&lang=js&"
export * from "./ChatPaletteTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteTabs.vue"
export default component.exports